import { Checkbox as MuiCheckbox, CheckboxProps as MuiCheckboxProps, styled } from "@mui/material";

const StyledCheckbox = styled(MuiCheckbox)(({ theme }) => {
  return {
    color: theme.palette.toggleButton.background,
    "&.Mui-checked": {
      color: theme.palette.toggleButton.background,
    },
  };
});

interface CheckboxProps extends MuiCheckboxProps {}

export const Checkbox: React.FC<CheckboxProps> = ({ ...props }) => {
  return <StyledCheckbox {...props} />;
};

export default Checkbox;
